import { AddCircle } from '@mui/icons-material';
import { Button, type ButtonProps } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '~/components/Tooltip';
import { NewZoneDialog } from './new-zone-dialog';

export interface AddZoneButtonProps extends Omit<ButtonProps, 'children'> {
  disabled: boolean;
  title?: string;
}

export const AddZoneButton = ({ disabled, title, ...props }: AddZoneButtonProps) => {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Tooltip title={title}>
        <span>
          <Button
            color="primary"
            onClick={() => setDialogOpen(() => true)}
            startIcon={<AddCircle />}
            variant="contained"
            disabled={disabled}
            {...props}
          >
            {t('pages.layouts.detail.actions.add_zone')}
          </Button>
        </span>
      </Tooltip>
      <NewZoneDialog close={() => setDialogOpen(false)} open={dialogOpen} />
    </>
  );
};
